import { render } from "./_404.vue?vue&type=template&id=3bee6313&scoped=true"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"

import "./_404.vue?vue&type=style&index=0&id=3bee6313&scoped=scoped&lang=css"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3bee6313"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bee6313', script)) {
    api.reload('3bee6313', script)
  }
  
  module.hot.accept("./_404.vue?vue&type=template&id=3bee6313&scoped=true", () => {
    api.rerender('3bee6313', render)
  })

}


import exportComponent from "D:\\develop\\simo\\front\\website\\front-bc-huibentong-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bee6313"],['__file',"src/views/_404.vue"]])